import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CardWrapper = styled.div<{ width: number }>`
    width: ${(props) => props.width}px;
    height: 346px;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};
    overflow: hidden;
    cursor: pointer;
`;

export const CardContent = styled.div`
    width: 129px;
    height: 145px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 104px;
`;

export const CardCircle = styled.div`
    width: 74px;
    height: 74px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 50%;
    background-color: ${COLORS.BgMain};
    margin-bottom: 16px;
`;

export const CardArrow = styled.div<{ imgUrl: string }>`
    width: 26px;
    height: 14px;
    background-image: url('${(props) => props.imgUrl}');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
`;

export const CardLabel = styled.div`
    ${FONTS.H4};
    color: ${COLORS.Link};
`;
